import DataMapEditor from '@/components/DataMapEditor';

const DataMapEditorPage = () => {
  return (
    <>
      <DataMapEditor />
    </>
  );
};

export default DataMapEditorPage;
